var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let StyleTraits = (_dec = primitiveTrait({
  type: "string",
  name: "marker-size",
  description: "Marker size. Valid values are `small`, `medium`, or `large`. If the " + "value is a number, it is the size in pixels."
}), _dec2 = primitiveTrait({
  type: "string",
  name: "marker-color",
  description: "Marker color"
}), _dec3 = primitiveTrait({
  type: "string",
  name: "marker-symbol",
  description: "Marker symbol. (only supported with Cesium Primitives)"
}), _dec4 = primitiveTrait({
  type: "number",
  name: "marker-opacity",
  description: "Marker opacity."
}), _dec5 = primitiveTrait({
  type: "string",
  name: "marker-url",
  description: "Marker URL. (only supported with Cesium Primitives)"
}), _dec6 = primitiveTrait({
  type: "string",
  name: "stroke",
  description: "Stroke color."
}), _dec7 = primitiveTrait({
  type: "number",
  name: "stroke-opacity",
  description: "Stroke opacity."
}), _dec8 = primitiveTrait({
  type: "number",
  name: "stroke-width",
  description: "Stroke width."
}), _dec9 = primitiveTrait({
  type: "string",
  name: "marker-stroke",
  description: "Marker stroke color. (This is will override stroke for Point geojson-vt features) - not apart of simplestyle-spec and will not apply to cesium primitives"
}), _dec0 = primitiveTrait({
  type: "number",
  name: "marker-stroke-width",
  description: "Marker stroke width. (This is will override stroke-width for Point geojson-vt features) - not apart of simplestyle-spec and will not apply to cesium primitives"
}), _dec1 = primitiveTrait({
  type: "string",
  name: "polyline-stroke",
  description: "Polyline stroke color. (This is will override stroke for Polyline geojson-vt features) - not apart of simplestyle-spec and will not apply to cesium primitives"
}), _dec10 = primitiveTrait({
  type: "number",
  name: "polyline-stroke-width",
  description: "Polyline stroke width. (This is will override stroke-width for Polyline geojson-vt features) - not apart of simplestyle-spec and will not apply to cesium primitives"
}), _dec11 = primitiveTrait({
  type: "string",
  name: "polygon-stroke",
  description: "Polygon stroke color. (This is will override stroke for Polygon geojson-vt features) - not apart of simplestyle-spec and will not apply to cesium primitives"
}), _dec12 = primitiveTrait({
  type: "number",
  name: "polygon-stroke-width",
  description: "Polygon stroke width. (This is will override stroke-width for Polygon geojson-vt features) - not apart of simplestyle-spec and will not apply to cesium primitives"
}), _dec13 = primitiveTrait({
  type: "string",
  name: "fill",
  description: "Fill color."
}), _dec14 = primitiveTrait({
  type: "number",
  name: "fill-opacity",
  description: "Fill opacity."
}), _class = class StyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "marker-size", _descriptor, this);
    _initializerDefineProperty(this, "marker-color", _descriptor2, this);
    _initializerDefineProperty(this, "marker-symbol", _descriptor3, this);
    _initializerDefineProperty(this, "marker-opacity", _descriptor4, this);
    _initializerDefineProperty(this, "marker-url", _descriptor5, this);
    _initializerDefineProperty(this, "stroke", _descriptor6, this);
    _initializerDefineProperty(this, "stroke-opacity", _descriptor7, this);
    _initializerDefineProperty(this, "stroke-width", _descriptor8, this);
    _initializerDefineProperty(this, "marker-stroke", _descriptor9, this);
    _initializerDefineProperty(this, "marker-stroke-width", _descriptor0, this);
    _initializerDefineProperty(this, "polyline-stroke", _descriptor1, this);
    _initializerDefineProperty(this, "polyline-stroke-width", _descriptor10, this);
    _initializerDefineProperty(this, "polygon-stroke", _descriptor11, this);
    _initializerDefineProperty(this, "polygon-stroke-width", _descriptor12, this);
    _initializerDefineProperty(this, "fill", _descriptor13, this);
    _initializerDefineProperty(this, "fill-opacity", _descriptor14, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "marker-size", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "marker-color", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "marker-symbol", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "marker-opacity", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "marker-url", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "stroke", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "stroke-opacity", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "stroke-width", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "marker-stroke", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "marker-stroke-width", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "polyline-stroke", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "polyline-stroke-width", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "polygon-stroke", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "polygon-stroke-width", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "fill", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "fill-opacity", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { StyleTraits as default };